import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { getCurrentEnv } from "@sfly/uig-current-environment-util";

class Toolbar extends Component {

    constructor(props){
        super(props);
        this.state = {
            queryString: queryString.parse(window.location.search)
        }
    }

    render() {
        /**
         * TODO: Make these environment specific like `company.link_logo_1${getCurrentEnv() === 'production' ? '' : '.'+ getCurrentEnv()}
         * to produce something like company.link_logo_1.dev, company.link_logo_2.kappa, etc.
         * See https://github.com/sflyinc-shutterfly/ui-guild/tree/master/packages/uig-current-environment-util#getcurrentenv
         */
        let logoUrl1 = this.props.translator.translate(`company.link_logo_1${getCurrentEnv() === 'production' ? '' : `_${getCurrentEnv()}`}`);
        logoUrl1 = this.props.fromAmazon ? logoUrl1 + '?fromAmazon=true' : logoUrl1;
        const logoUrl2 = this.props.translator.translate(`company.link_logo_2${getCurrentEnv() === 'production' ? '' : `_${getCurrentEnv()}`}`);
        return (
            <header className={`zuul-toolbar ${this.state.queryString.source ? 'zuul-source-override' : ''} ${this.props.fromAmazon ? 'logo-start' : ""}`}>
                <div tabIndex="0" aria-label={this.props.translator.translate('company.label_logo_1')} className={`logo logo1 ${this.props.fromAmazon ? 'logoAmazon' : ""}`} onClick={() => { window.location.assign(logoUrl1) }}></div>
                {!this.props.fromAmazon ? <div tabIndex="0.1" aria-label={this.props.translator.translate('company.label_logo_2')} className={'logo logo2'} onClick={() => { window.location.assign(logoUrl2) }}>Community</div>:"" }
                
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        translator: state.app.translator
    };
};

export default connect(mapStateToProps)(Toolbar);
